import AppMenu from './app-menu';

const AppSidebar = () => {
    return <AppMenu />;
};

export default AppSidebar;
